import template from 'text!./wizard-tile.html';

export default [function () {
    return {
        restrict: 'E',
        replace: false,
        transclude: true,
        scope: {
            state: '&',
            callback: '&',
            flavor: '@',
            icon: '@',
            text: '@'
        },
        template: template
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/tiles/Wizard/WizardTile.js
// module id = 1163
// module chunks = 0